// extracted by mini-css-extract-plugin
export default {"rrPlot":"RRIntervalPlot_rrPlot__rg+s0","rrPlotTitle":"RRIntervalPlot_rrPlotTitle__QOA1V","canvas":"RRIntervalPlot_canvas__nawW1","topSVG":"RRIntervalPlot_topSVG__LLII8"};